"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __values = this && this.__values || function (o) {
  var s = typeof Symbol === "function" && Symbol.iterator,
    m = s && o[s],
    i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
    next: function () {
      if (o && i >= o.length) o = void 0;
      return {
        value: o && o[i++],
        done: !o
      };
    }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createHighlighter = exports.makeSpans = exports.simplifyAreas = exports.compareArea = exports.findAll = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var R = __importStar(require("../../utils/ramda"));
function findAll(targetText, snippet) {
  var matches = [];
  var pos = targetText.indexOf(snippet, 0);
  while (pos >= 0) {
    matches.push([pos, snippet.length]);
    pos = targetText.indexOf(snippet, pos + 1);
  }
  return matches;
}
exports.findAll = findAll;
var compareArea = function (_a, _b) {
  var _c = __read(_a, 2),
    start1 = _c[0],
    len1 = _c[1];
  var _d = __read(_b, 2),
    start2 = _d[0],
    len2 = _d[1];
  return start1 === start2 ? len1 - len2 : start1 - start2;
};
exports.compareArea = compareArea;
function simplifyAreas(matches) {
  var e_1, _a;
  var areas = [];
  var start = 0,
    length = 0;
  try {
    for (var matches_1 = __values(matches), matches_1_1 = matches_1.next(); !matches_1_1.done; matches_1_1 = matches_1.next()) {
      var _b = __read(matches_1_1.value, 2),
        st = _b[0],
        ln = _b[1];
      var overlaps = start + length >= st;
      if (length > 0 && overlaps) {
        var end = Math.max(start + length, st + ln);
        start = Math.min(start, st);
        length = end - start;
      } else {
        if (length > 0) areas.push([start, length]);
        start = st;
        length = ln;
      }
    }
  } catch (e_1_1) {
    e_1 = {
      error: e_1_1
    };
  } finally {
    try {
      if (matches_1_1 && !matches_1_1.done && (_a = matches_1.return)) _a.call(matches_1);
    } finally {
      if (e_1) throw e_1.error;
    }
  }
  if (length > 0) areas.push([start, length]);
  return areas;
}
exports.simplifyAreas = simplifyAreas;
function makeSpans(targetText, highlightAreas, highlightClass) {
  var e_2, _a;
  var spans = [];
  var pushSpan = function (txt, i, hc) {
    if (hc === void 0) {
      hc = false;
    }
    return hc ? spans.push((0, jsx_runtime_1.jsx)("span", __assign({
      className: highlightClass
    }, {
      children: txt
    }), "".concat(i, "-").concat(txt))) : spans.push((0, jsx_runtime_1.jsx)("span", {
      children: txt
    }, "".concat(i, "-").concat(txt)));
  };
  var last = 0;
  var i = 0;
  try {
    for (var highlightAreas_1 = __values(highlightAreas), highlightAreas_1_1 = highlightAreas_1.next(); !highlightAreas_1_1.done; highlightAreas_1_1 = highlightAreas_1.next()) {
      var _b = __read(highlightAreas_1_1.value, 2),
        start = _b[0],
        length_1 = _b[1];
      if (start > last) pushSpan(targetText.substring(last, start), i++);
      last = start + length_1;
      pushSpan(targetText.substring(start, last), i, true);
      ++i;
    }
  } catch (e_2_1) {
    e_2 = {
      error: e_2_1
    };
  } finally {
    try {
      if (highlightAreas_1_1 && !highlightAreas_1_1.done && (_a = highlightAreas_1.return)) _a.call(highlightAreas_1);
    } finally {
      if (e_2) throw e_2.error;
    }
  }
  if (last < targetText.length) pushSpan(targetText.substring(last, targetText.length), i);
  return spans;
}
exports.makeSpans = makeSpans;
var createHighlighter = function (getName, highlightClass, sizeThreshold) {
  return function (nodeId, textToFind) {
    var targetText = getName(nodeId);
    var snippetArray = textToFind.toLowerCase().split(/\s+/).filter(function (x) {
      return x.length >= sizeThreshold;
    });
    if (snippetArray.length === 0) {
      return [(0, jsx_runtime_1.jsxs)("span", {
        children: [" ", targetText]
      }, "0-".concat(targetText))];
    }
    var matchedAreas = R.chain(function (snippet) {
      return findAll(targetText.toLowerCase(), snippet);
    }, snippetArray).sort(exports.compareArea);
    var simplifiedAreas = simplifyAreas(matchedAreas);
    return makeSpans(targetText, simplifiedAreas, highlightClass);
  };
};
exports.createHighlighter = createHighlighter;